import { Map, Popup, Sidebar, Source } from '@/components/controls';
import { parseKeyValues } from '@/utils';
import { sortOptions, types } from '@/utils/constants';
import { Box } from '@mui/material';
import { useCallback, useState } from 'react';
// import { useLiveStream } from './useLiveStream';
import { useStreamingFeatureCollections } from './useStreamingFeatureCollections';

export function Live() {
  const [search, setSearch] = useState(
    Object.fromEntries(Array.from(Object.keys(types), (key) => [key, ''])),
  );
  const [sort, setSort] = useState(
    Object.fromEntries(
      Array.from(Object.keys(types), (key) => [
        key,
        { sortBy: sortOptions[key][0].value, sortDesc: false },
      ]),
    ),
  );
  const [filter, setFilter] = useState(
    Object.fromEntries(Array.from(Object.keys(types), (key) => [key, {}])),
  );
  // const { featureCollections, filterValues } = useLiveStream(
  //   filter,
  //   search,
  //   sort,
  // );
  const { featureCollections, filterValues } = useStreamingFeatureCollections(
    search,
    sort,
    filter,
  );
  const [mapHoverInfo, setMapHoverInfo] = useState(null);
  const [listHoverInfo, setListHoverInfo] = useState(null);
  const [hiddenSources, setHiddenSources] = useState([]);

  const handleMouseMove = useCallback((event) => {
    const hoveredFeature =
      event.features && event.features[0]
        ? {
            ...event.features[0],
            properties: parseKeyValues(event.features[0].properties),
          }
        : null;

    setMapHoverInfo({
      feature: hoveredFeature,
      longitude: event.lngLat.lng,
      latitude: event.lngLat.lat,
    });
  }, []);

  function handleTabClick(event, value) {
    setHiddenSources((hiddenSources) =>
      hiddenSources.includes(value)
        ? hiddenSources.filter((source) => source !== value)
        : [...hiddenSources, value],
    );
  }

  function handleListItemHover(hoverInfo) {
    setListHoverInfo(hoverInfo);
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <title>IR3 | Live</title>
      <Box
        sx={{
          width: 320,
          height: 'calc(100vh - 48px)',
          borderRight: 1,
          borderColor: 'divider',
          flexShrink: 0,
        }}
      >
        <Sidebar
          featureCollections={featureCollections}
          filterValues={filterValues}
          hoveredFeature={mapHoverInfo?.feature}
          hiddenTabs={hiddenSources}
          onTabClick={handleTabClick}
          onHover={handleListItemHover}
          search={search}
          onSearchChange={setSearch}
          sort={sort}
          onSortChange={setSort}
          filter={filter}
          onFilterChange={setFilter}
        />
      </Box>
      <Map
        searchable
        sx={{ flexGrow: 1, height: 'calc(100vh - 48px)' }}
        interactiveLayerIds={Object.keys(featureCollections).map(
          (key) => `${key}-symbol-layer`,
        )}
        onMouseMove={handleMouseMove}
      >
        {Object.entries(featureCollections)
          .sort(([id1], [id2]) => types[id1].zIndex - types[id2].zIndex)
          .map(([id, data]) => (
            <Source
              key={id}
              id={id}
              data={data}
              visibility={hiddenSources.includes(id) ? 'none' : 'visible'}
            />
          ))}
        {mapHoverInfo?.feature && <Popup hoverInfo={mapHoverInfo} />}
        {listHoverInfo && <Popup hoverInfo={listHoverInfo} />}
      </Map>
    </Box>
  );
}
